import { useHistory } from 'react-router-dom';
import profileImage from '../../img/profile-image.svg';

const ProfilePicture = () => {

    const history = useHistory();

    const handleImageClick = () => {
        history.push("/profile")
    }

    return(
        <div style={{cursor: "pointer"}}onClick={handleImageClick} className="profile-image">
            <img alt="Profile Image" src={profileImage}></img>
        </div>
    )
};

export default ProfilePicture;

